import shadows from '$tablet-app/src/app/theme/shadows';
import styled from 'styled-components/native';

const Card = styled.View`
  border-radius: 15px;
  background-color: white;
  ${shadows.small}
`;

export default Card;
